import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-mirrors',
  storeModule.createStoreModule('real-estate-developments-mirrors')
)
